import {useState} from "react";
import {Box,TextField,InputAdornment,Button} from '@mui/material';
import {consoleLog} from '../../../core/utilities/Utilities';

const FilterText=({filterCallBack,filterName,application,filterLabel})=>{
    const [filterValue,setFilterValue]=useState();

    const handleSearch=()=>{
        consoleLog({file:'FilterText.js',context:'handleSearch',arg_name:'filterValue',arg_value:filterValue});
        filterCallBack(filterValue);
    }

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                InputProps={{
                    endAdornment:(
                        <InputAdornment position="end">
                            <Button
                                variant="contained"
                                size="small"
                                color="primary"
                                onClick={(e)=>handleSearch()}>{application.getLocale("SearchLabel")}
                            </Button>
                        </InputAdornment>
                    )
                }}
                sx={{mt:0,mb:"1px","& .MuiInputBase-input":{height:"1.0rem",fontSize:"0.8rem"},"& .MuiInputLabel-root":{fontSize:"0.8rem"}}}
                id={filterName}
                name={filterName}
                variant="outlined"
                size="small"
                label={filterLabel}
                value={filterValue||''}
                margin="normal"
                onChange={(e)=>{setFilterValue(e.target.value);}}
                onKeyDown={(e)=>{
                    if(e.key==="Enter"){
                        e.preventDefault();
                        handleSearch();
                    }
                }}
            />
        </Box>
    );
}

export default FilterText;
